var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header text-left"},[_c('h2',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.text)),(_vm.badge !== undefined)?_c('b-badge',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.badge))]):_vm._e()],1),_c('hr',{staticClass:"m-0"})])}
var staticRenderFns = []

export { render, staticRenderFns }